module.exports = __webpack_public_path__ + "img/image_005.8b274251.png";